export default {
  products: [],
  product: undefined,
};
